export const INPUT_HEIGHT = 82;
const LABEL_HEIGHT = 32;
export const INPUT_WITH_LABEL_HEIGHT = INPUT_HEIGHT + LABEL_HEIGHT;

export const HEADER_HEIGHT = '4.25rem';
export const EDITOR_NAVIGATION_HEIGHT = 56;

export const VERTICAL_VIDEO_HEIGHT = '51.5vh';
export const VERTICAL_VIDEO_WIDTH = `calc(${VERTICAL_VIDEO_HEIGHT} / (16/9))`; // 16:9 resolution
